export function trimEndSlash(str: string | null | undefined): string | null {
  if (str == null) {
    return null;
  }
  return str.endsWith('/') ? str.slice(0, -1) : str;
}

export const removeSpecialSymbols = (str: string): string => {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[.,/\\!@#$%^&*()_+={}[\]:;"'<>?|`~\s-]/g, '');
};

export const toKebabCase = (str: string): string => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
export const toCamelCase = (str: string): string =>
  str
    .replace(/^[^a-zA-Z0-9]+/, '')
    .replace(/[^a-zA-Z0-9]+(.)/g, (_match, chr: string) => chr.toUpperCase())
    .replace(/^[A-Z]/, (chr) => chr.toLowerCase());

export function toLowerCase(value: unknown): string {
  return typeof value === 'string' ? value.toLowerCase() : '';
}

const stringHelpers = {
  trimEndSlash,
  removeSpecialSymbols,
  toKebabCase,
  toCamelCase,
  toLowerCase,
};

export type StringHelpers = typeof stringHelpers;

export default stringHelpers;
